/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePasswordRequest
 */
export interface UpdatePasswordRequest {
    /**
     * 新パスワード 半角英数2種利用8文字以上
     * @type {string}
     * @memberof UpdatePasswordRequest
     */
    newPassword: string;
}

/**
 * Check if a given object implements the UpdatePasswordRequest interface.
 */
export function instanceOfUpdatePasswordRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "newPassword" in value;

    return isInstance;
}

export function UpdatePasswordRequestFromJSON(json: any): UpdatePasswordRequest {
    return UpdatePasswordRequestFromJSONTyped(json, false);
}

export function UpdatePasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newPassword': json['new_password'],
    };
}

export function UpdatePasswordRequestToJSON(value?: UpdatePasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'new_password': value.newPassword,
    };
}

